export const FEED_KEY = 'feed';
export const getFeedKey = (args) => args ? [FEED_KEY, args] : [FEED_KEY];
//# sourceMappingURL=feed.keys.js.map